module.exports = __webpack_public_path__ + "media/images/app/products/rings_long_lollipops-d396e1453c0cb41841f8c08ab86c69c0.webp";